type Props = {
  onClick: () => void;
  label?: string;
  selected: boolean;
  size: "3xl" | "2xl" | "xl";
};

const mapTextToRadioSize: Record<Props["size"], string> = {
  xl: "1.5rem",
  "2xl": "1.8rem",
  "3xl": "2rem",
};

export const RadioButton = ({ onClick, label, selected, size }: Props) => {
  return (
    <div className="flex items-center" onClick={() => onClick()}>
      <div
        className="flex items-center justify-center cursor-pointer"
        style={{
          width: mapTextToRadioSize[size],
          height: mapTextToRadioSize[size],
          borderRadius: "100%",
          border: "2px solid grey",
        }}
      >
        {selected ? (
          <div
            className="bg-grey-medium"
            style={{
              width: `calc(${mapTextToRadioSize[size]} - 10px)`,
              height: `calc(${mapTextToRadioSize[size]} - 10px)`,
              borderRadius: "100%",
            }}
          ></div>
        ) : (
          ""
        )}
      </div>
      {label ? (
        <div
          className={`text-${size || "xl"} text-grey-dark`}
          style={{
            marginLeft: 10,
            lineHeight: "10rem",
          }}
        >
          {label}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
